import { ChangeEvent, useCallback, useState } from 'react'

import PlainInput from 'app/common/ui/PlainInput'
import { BankDetail, BankDetailProps, BankKey } from 'app/dataTypes/account/bankDetails/BankDetailsTypes'
import PlainInputBIC from 'app/common/ui/PlainInput/PlainInputBIC'
import PlainInputCheckingAccount from 'app/common/ui/PlainInput/PlainInputCheckingAccount'

import { clearMask } from './clearMask'
import styles from './BankDetailsFormControls.scss'


export const bankDetailsControls = {
  Bik: 'bankDetailsProps.bic',
  CorrAccount: 'bankDetailsProps.corr_account',
  BankTitle: 'bankDetailsProps.bank_title',
  CheckingAccount: 'bankDetailsProps.checking_account',
} as const

type Props = {
  className?: string
  bankDetailsProps: BankDetailProps
  loading?: boolean
  disabled?: boolean
  onChangeValue: (value: BankDetail) => void
  onBikRequestAndValidate: (bik: string) => Promise<void>
  bikErrorText: string
  corrAccountLength: number
}

export function BankDetailsFormControls({
  className,
  bankDetailsProps,
  loading,
  disabled,
  onChangeValue,
  onBikRequestAndValidate,
  bikErrorText,
  corrAccountLength,
}: Props) {
  const [checkingAccountErrorText, setCheckingAccountErrorText] = useState<string>('')
  const [pendingBik, setPendingBik] = useState(false)

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>, nameKey: BankKey): void => {
    const { value } = event.target
    onChangeValue({ [nameKey]: value })
  }, [onChangeValue])

  const handleChangeBick = useCallback(async (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget
    onChangeValue({ bik: value })
    setPendingBik(true)
    await onBikRequestAndValidate(clearMask(value))
    setPendingBik(false)
  }, [onChangeValue, onBikRequestAndValidate])

  const onValidateHandler = useCallback(() => {
    const checkingAccount = clearMask(bankDetailsProps.checkingAccount)
    if (checkingAccount.length !== corrAccountLength) { // TODO перенести валидацию в dataProviders, как bik
      const text = `Введите корректное значение — ${corrAccountLength} символов`
      setCheckingAccountErrorText(text)
    } else {
      setCheckingAccountErrorText('')
    }
  }, [bankDetailsProps.checkingAccount, corrAccountLength])

  return (
    <div className={className}>
      <div className={styles.row}>
        <PlainInputBIC // TODO заменить на ui-next/plain-input
          label="БИК:"
          className={styles.mask}
          name={bankDetailsControls.Bik}
          value={bankDetailsProps.bik}
          onChange={handleChangeBick}
          onBlur={handleChangeBick}
          loading={loading}
          disabled={disabled}
          placeholder="Не указано"
          errorText={bikErrorText}
          isError={!!bikErrorText}
        />
        <PlainInput // TODO заменить на ui-next/plain-input
          label="Корреспондентский счет (к/с):"
          name={bankDetailsControls.CorrAccount}
          value={bankDetailsProps.corrAccount}
          onChange={value => handleChange(value, 'corrAccount')}
          loading={loading || pendingBik}
          disabled
          placeholder="Нет данных"
        />
      </div>

      <PlainInput // TODO заменить на ui-next/plain-input
        label="Наименование банка:"
        name={bankDetailsControls.BankTitle}
        value={bankDetailsProps.bankTitle}
        onChange={value => handleChange(value, 'bankTitle')}
        disabled
        loading={loading || pendingBik}
        placeholder="Нет данных"
      />

      <PlainInputCheckingAccount // TODO заменить на ui-next/plain-input
        label="Введите расчетный счет (р/с):"
        className={styles.mask}
        name={bankDetailsControls.CheckingAccount}
        value={bankDetailsProps.checkingAccount}
        onChange={value => handleChange(value, 'checkingAccount')}
        disabled={disabled}
        loading={loading}
        placeholder="Не указано"
        onBlur={onValidateHandler}
        errorText={checkingAccountErrorText}
        isError={!!checkingAccountErrorText}
      />
    </div>
  )
}
